import React from 'react';

const DividerLine = React.forwardRef<any, Props>((({
  width,
  height,
  backgroundColor,
  marginBottom,
  marginTop,
  marginLeft,
  marginRight,
  opacity,
}, ref) => {
  return (
    <div ref={ref} style={{ height: height || 1, width, backgroundColor: backgroundColor || '#EAEAEA', marginTop, marginBottom, marginLeft, marginRight, opacity }} />
  );
}));

export interface Props {
  width?: number | string;
  height?: number | string;
  backgroundColor?: string;
  marginTop?: number | string;
  marginBottom?: number | string;
  marginLeft?: number | string;
  marginRight?: number | string;
  opacity?: number;
}

export default DividerLine;
